import React from 'react'

export default function Contact() {
  return (
    <>
    <section className=''>
<div className="p-20 md:p-8 w-full overflow-y-auto">
 <h1 className='text-center text-3xl md:text-4xl font-semibold md:font-bold text-white'>
Contact Section
 </h1>
</div>

 
  
    </section>
    
    
    
    </>
  )
}
